import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { StickyCTA } from "./StickyCTA";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[color:var(--fk-bg)] text-[color:var(--fk-text)]">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};
